import { Box, Button, Chip, Divider, Grid, LinearProgress, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import UserAutoComplete from '../../Components/AutoCompletes/UserAutoComplete';
import { toast } from 'react-toastify';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import UsersVideoCard from './components/UsersVideoCard';
import api from '../../conf/api';
import BackupIcon from '@mui/icons-material/Backup';
import WooglobeIMG from "../../static/images/wooglobeIcon.png"
import axios from 'axios';


const WooglobeSubmition = () => {
    const [selectedUser, setSelectedUser] = useState([]);
    const [compilationData, setCompilationData] = useState({});
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);


    const initalizeCompilationData = {
        question4: "",
        video_title: "",
        category: undefined,
        tags: [],
        videos: [],
        errors: []
    }
    const handleUserChange = (user) => {
        if (user) {
            const old_users = selectedUser.find((usr) => usr.id === user?.id);
            if (!old_users) {
                setSelectedUser((pre) => [...pre, user]);
                setCompilationData((pre) => ({ ...pre, [user?.id]: initalizeCompilationData }));
            } else {
                toast.error("User already selected");
            }
        }
    };
    const handleRemoveUser = (user) => {
        const new_users = selectedUser.filter((usr) => usr.id !== user?.id);
        setSelectedUser(new_users);
    }
    const validateCompilationData = () => {
        let isValid = true;
        const updatedCompilationData = { ...compilationData };

        selectedUser.forEach((user) => {
            const userCompilation = compilationData[user?.id];
            const errors = [];
            if (!userCompilation) {
                return false;
            }
            if (!userCompilation.question4) {
                errors.push("background story/context is missing.");
            }

            if (!userCompilation.video_title) {
                errors.push("Video title is required.");
            }

            if (userCompilation.videos.length === 0) {
                errors.push("At least one video is required.");
            }

            if (!userCompilation.category?.hasOwnProperty("id")) {
                errors.push("Select one of the category");
            }
            if (userCompilation.tags.length === 0) {
                errors.push("At least one tag is required.");
            }
            if (errors.length > 0) {
                isValid = false;
            }
            updatedCompilationData[user?.id] = {
                ...userCompilation,
                errors: errors,
            };
        });

        setCompilationData(updatedCompilationData);
        return isValid;
    };
    const handleSubmit = async () => {
        setLoading(true);
        if (validateCompilationData()) {
            toast.info("Submitting videos for licensing...");
            const updatedCompilationData = { ...compilationData };

            Object.keys(updatedCompilationData).forEach(userId => {
                if (updatedCompilationData[userId].category?.id) {
                    updatedCompilationData[userId].category = updatedCompilationData[userId].category.id;
                }
            });
            api.post("/videos/wooglobe-submitions/", updatedCompilationData, { timeout: 600 * 1000 * 100 })
                .then((res) => {
                    const { status, data } = res;

                    if (status === 200) {
                        let responseData;

                        try {
                            // If backend sent a JSON string, parse it
                            responseData = typeof data.data === "string"
                                ? JSON.parse(data.data)
                                : data.data;
                        } catch (error) {
                            toast.error("Failed to parse response from server.");
                            console.error("Parse Error:", error);
                            return;
                        }

                        // Split into success and error responses
                        const successUsers = [];
                        const errorUsers = [];

                        responseData.forEach((userResp) => {
                            const userId = Object.keys(userResp).find((key) => key !== "status" && key !== "error");
                            const statusCode = userResp.status;

                            if (statusCode === 200) {
                                successUsers.push(userId);
                            } else {
                                errorUsers.push({
                                    userId,
                                    reason: userResp.error || userResp[userId],
                                });
                            }
                        });

                        if (successUsers.length > 0) {
                            toast.success(`Videos licensed successfully for users: ${successUsers.join(", ")}`);
                            // Remove compilation on success
                            const preCompiloations = { ...compilationData };
                            successUsers.forEach(u => {
                                delete preCompiloations[u];
                            })
                            setCompilationData(p => preCompiloations);

                            setSelectedUser(preUser => preUser.filter(u => !successUsers.includes(u.id)));
                        }

                        if (errorUsers.length > 0) {
                            // const preData = compilationData;
                            errorUsers.forEach(({ userId, reason }) => {
                                toast.error(`User ${userId} failed: ${reason}`);
                                // preData[userId] = { ...preData[userId], errors: [reason] }
                            });
                            // Show error ON failed submitions
                            // setCompilationData(preData);
                        }
                    } else {
                        toast.error("Error in licensing videos. Unexpected status code.");
                    }
                })
                .catch((err) => {
                    console.error("API Error:", err);
                    toast.error("Error in licensing videos.");
                }).finally(res => {
                    setLoading(false);
                });
        } else {
            setLoading(false);
            toast.error("Please fix the errors before submitting.");
        }
    };
    const FetchCategories = async () => {
        axios.get(process.env.REACT_APP_WEBSITE + "/apis/categories/", { params: { limit: 2000} }).then(res => {
            if (res.status === 200) {
                setCategories(res.data.results);
            }
        }).catch(err => {
        })

    }

    useEffect(() => {
        FetchCategories();
    }, [])


    const selectedCount = selectedUser.length;
    const readyCount = selectedUser.filter((u) => {
        const c = compilationData[u.id];
        return c && c.videos.length > 0 && c.video_title && c.question4 && c.category?.id && c.tags.length > 0;
    }).length;

    return (
        <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1400, mx: 'auto', width: '100%' }}>
            <Box component="header" display="flex" gap={2} alignItems="center" mb={3}>
                <Box component="img" src={WooglobeIMG} alt="" height={56} />
                <Box>
                    <Typography variant="h4" component="h1" fontWeight={600}>Wooglobe Submission</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Pick a creator, choose the videos they are handing over, add the story details, then submit for licensing.
                    </Typography>
                </Box>
            </Box>

            <Paper variant="outlined" sx={{ p: 2, mb: 3, maxWidth: 520 }}>
                <Typography variant="subtitle1" component="h2" fontWeight={600} mb={1}>
                    1. Select creators
                </Typography>
                <UserAutoComplete size="large" value={selectedUser} onChange={handleUserChange} params={{ is_creator: true, page_size: 1000 }} emptySelection selectUserObj />
            </Paper>

            {selectedCount === 0 ? (
                <Paper variant="outlined" sx={{ p: 4, textAlign: 'center', borderStyle: 'dashed' }}>
                    <GroupRoundedIcon sx={{ fontSize: 40, color: 'text.disabled' }} aria-hidden />
                    <Typography variant="h6" component="p" mt={1}>No creators selected yet</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Search for a creator above to start a submission.
                    </Typography>
                </Paper>
            ) : (
                <Box component="section" aria-labelledby="selected-creators-heading">
                    <Box display="flex" gap={1.5} alignItems="center" flexWrap="wrap" mb={2}>
                        <GroupRoundedIcon color="primary" aria-hidden />
                        <Typography id="selected-creators-heading" variant="h6" component="h2" fontWeight={600}>
                            2. Add video details
                        </Typography>
                        <Chip size="small" label={`${readyCount} of ${selectedCount} ready`} color={readyCount === selectedCount ? 'success' : 'default'} />
                    </Box>
                    <Grid container spacing={2} alignItems="flex-start">
                        {selectedUser.map((user) => (
                            <Grid item key={user.id} xs={12} md={6} xl={4}>
                                <UsersVideoCard categories={categories} user={user} onRemove={handleRemoveUser} compilationData={compilationData} setCompilationData={setCompilationData} showLoader={setLoading} />
                            </Grid>
                        ))}
                    </Grid>

                    <Divider sx={{ my: 3 }} />
                    <Box display="flex" flexDirection="column" gap={1} maxWidth={420} aria-live="polite">
                        {loading && <LinearProgress aria-label="Submitting videos" />}
                        <Button
                            disabled={loading}
                            variant="contained"
                            size="large"
                            startIcon={<BackupIcon />}
                            onClick={handleSubmit}
                            sx={{ minHeight: 48 }}
                        >
                            {loading ? 'Working…' : `Submit ${selectedCount} creator${selectedCount > 1 ? 's' : ''} for licensing`}
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default WooglobeSubmition;
